import React, {
  useState
} from "react";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionToggle,
  Card,
  CardBody,
  CardTitle,
  Content,
  Grid,
  GridItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

import { Link } from "react-router-dom";

import {
  activeProjects,
  archivedProjects,
  ProjectPageHeader
} from "apps/school-site/features/projects";


const ProjectsPage = () => {
  const [expandedProject, setExpandedProject] =
    useState(null);

  const toggleProject = (projectId) => {
    setExpandedProject((current) =>
      current === projectId
        ? null
        : projectId
    );
  };

  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <ProjectPageHeader
            title="Projekty"
            description="Aktualne i zakończone projekty realizowane przez CKZiU w Wyrzysku."
          />
        </StackItem>

        {activeProjects.length > 0 && (
  <StackItem>
    <Grid>
      <GridItem
        span={12}
        md={8}
        mdOffset={2}
      >
        <Stack hasGutter>
          <StackItem>
            <Content>
              <h2>
                Aktualne projekty
              </h2>
            </Content>
          </StackItem>

          <StackItem>
            <Grid hasGutter>
              {activeProjects.map((project) => (
                  <GridItem
                    key={project.id}
                    span={12}
                    md={6}
                  >
                    <Card
                      isGlass
                      isFullHeight
                    >
                      <CardTitle>
                        {project.label}
                      </CardTitle>

                      <CardBody>
                        <Stack hasGutter>
                          {project.description && (
                            <StackItem>
                              <Content>
                                <p>
                                  {project.description}
                                </p>
                              </Content>
                            </StackItem>
                          )}

                          <StackItem>
                            <Content>
                              <Link to={project.to}>
                                Zobacz projekt
                              </Link>
                            </Content>
                          </StackItem>
                        </Stack>
                      </CardBody>
                    </Card>
                  </GridItem>
                ))}
              </Grid>
            </StackItem>
          </Stack>
        </GridItem>
      </Grid>
    </StackItem>
  )}

        {archivedProjects.length > 0 && (
          <StackItem>
            <Grid>
              <GridItem
                span={12}
                md={8}
                mdOffset={2}
              >
                <Stack hasGutter>
                  <StackItem>
                    <Content>
                      <h2>
                        Archiwalne projekty
                      </h2>

                      <p>
                        Zakończone projekty realizowane przez szkołę.
                      </p>
                    </Content>
                  </StackItem>

                  <StackItem>
                    <Accordion>
                      {archivedProjects.map((project) => {
                        const isExpanded =
                          expandedProject === project.id;

                        return (
                          <AccordionItem
                            key={project.id}
                            isExpanded={isExpanded}
                          >
                            <AccordionToggle
                              id={`${project.id}-toggle`}
                              onClick={() =>
                                toggleProject(project.id)
                              }
                            >
                              {project.label}
                            </AccordionToggle>

                            <AccordionContent
                              id={`${project.id}-content`}
                              aria-labelledby={`${project.id}-toggle`}
                            >
                              <Content>
                                {project.description && (
                                  <p>
                                    {project.description}
                                  </p>
                                )}

                                <p>
                                  {project.external ? (
                                    <a
                                      href={project.href}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Zobacz informacje o projekcie
                                    </a>
                                  ) : (
                                    <Link to={project.to}>
                                      Zobacz szczegóły projektu
                                    </Link>
                                  )}
                                </p>
                              </Content>
                            </AccordionContent>
                          </AccordionItem>
                        );
                      })}
                    </Accordion>
                  </StackItem>
                </Stack>
              </GridItem>
            </Grid>
          </StackItem>
        )}
      </Stack>
    </PageSection>
  );
};

export default ProjectsPage;